<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-icon card-header-warning">
            <div class="card-icon">
              <i class="material-icons">assignment</i>
            </div>
            <h4 class="card-title ">Logovi</h4>
          </div>
          <mat-tab-group>
            <mat-tab label="Nije u spisku">
              <div class="table-responsive" *ngIf="spiskovi.length > 0">
                <table class="table">
                  <thead class="text-primary">
                    <tr>
                      <th>Vreme</th>
                      <th>Poruka</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let spis of spiskovi">
                      <td>{{spis.vreme_upisa | date: 'dd.MM.yyyy HH:mm:ss'}}</td>
                      <td>{{spis.tekst}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div *ngIf="spiskovi.length == 0">
                <i><b>{{message}}</b></i>
              </div>
            </mat-tab>
            <mat-tab label="Greska">
              <div class="table-responsive" *ngIf="greske.length > 0">
                <table class="table">
                  <thead class="text-primary">
                    <tr>
                      <th>Vreme</th>
                      <th>Poruka</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let greska of greske">
                      <td>{{greska.vreme_upisa | date: 'dd.MM.yyyy HH:mm:ss'}}</td>
                      <td>{{greska.tekst}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div *ngIf="greske.length == 0">
                <i><b>{{message}}</b></i>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>

      </div>
    </div>
  </div>
</div>